module.exports = __webpack_public_path__ + "static/media/header_text.6e4b866c.png";